export const calcDownPercentage = ({
  list_price,
  down_payment,
  decimals = false // Optional parameter to control whether decimals are shown
}: {
  list_price: number
  down_payment: number
  decimals?: boolean // Allow either true or false
}) => {
  const percentage = (down_payment / list_price) * 100

  // If decimals is true, return the percentage with exactly two decimal places
  if (decimals) {
    return `${percentage.toFixed(2)}%` // Returns as a string with two decimal places
  }

  // If decimals is false, return the percentage as an integer
  return `${Math.round(percentage)}%` // No decimal places
}
